import React from 'react';
import styles from './ProductButton.module.css';

interface FloatingButtonProps {
    onClick: () => void;
    icon?: React.ReactNode;
    label?: string;
    position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
    className?: string;
}

const ProductButton: React.FC<FloatingButtonProps> = ({
                                                          onClick,
                                                          icon,
                                                          label,
                                                          position = 'bottom-right',
                                                          className
                                                      }) => {
    return (
        <button
            className={`${styles.floatingButton} ${styles[position]} ${className || ''}`}
            onClick={onClick}
            aria-label={label}
            title={label}
        >
            {icon}
            {label && <span className={styles.label}>{label}</span>}
        </button>
    );
};

export default ProductButton;